/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-02 16:31:52
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-24 17:39:43
 * @FilePath: /unifyxp-v2-store-portal/src/router/Router.tsx
 */
import React from 'react';
import { Route, Switch } from './Components/Route';

import NotFound from 'src/pages/404';
import AuthorizedRoute from './AuthorizedRoute';
import PermissionRoute from './PermissionRoute';
import GeneralRoute from './GeneralRoute';
import { Container } from 'src/layout/Components/PageStructure/PageStructure';
// import { instanceType, AllTypes } from 'src/tools/helper';
// import { get } from 'lodash';

import { useScrollToTop } from 'src/tools/customHooks';
const Routers = ({ routes }) => {
  useScrollToTop(); //默认不会置顶

  return (
    <Container>
      <Switch>
        {routes.map((route, i) => {
          const subRoutes = route.subRoutes;

          // instanceType(route.subRoutes) === AllTypes.Function
          //   ? route.subRoutes(params)
          //   : route.subRoutes;
          return (
            <Route
              exact={subRoutes.some((r) => r.exact)}
              path={subRoutes.map((r) => r.path)}
              key={i}>
              <route.layout>
                {/* <Switch> */}

                {subRoutes.map((route) => {
                  let component;
                  if (route.isPrivate) {
                    if (
                      route.permissionGroup ||
                      route.roleGroup ||
                      route.permissionGroupGenerate
                    ) {
                      component = (
                        <PermissionRoute key={route.path} {...route} />
                      );
                    } else {
                      component = (
                        <AuthorizedRoute key={route.path} {...route} />
                      );
                    }
                  } else {
                    component = <GeneralRoute key={route.path} {...route} />;
                  }

                  return component;
                })}
                {/* </Switch> */}
              </route.layout>
            </Route>
          );
        })}

        <Route path='*' key='notfound'>
          <NotFound />
        </Route>
      </Switch>{' '}
    </Container>
  );
};

export default Routers;
